// Registered clinic staff are all labelled the same for now: FOH (front of
// house). The per-role dropdown was removed — registration is just name + an
// optional note. If distinct roles come back later, reintroduce a list here and
// wire a picker in the register / admin-add forms.
export const CLINIC_DEFAULT_ROLE = 'FOH';
